// extracted by mini-css-extract-plugin
module.exports = {"itemPage":"ItemPage-module--item-page--VHtIV","section":"ItemPage-module--section--15174","header":"ItemPage-module--header--M_Omb","body":"ItemPage-module--body--2Ktt8"};